import React, { useState } from 'react';
import { Tabs, Typography, Button, Breadcrumb, Space } from 'antd';
import { HomeOutlined, ShoppingOutlined, PlusOutlined, ImportOutlined, ShopOutlined } from '@ant-design/icons';
import OrdersList from '../components/orders/OrdersList';
import OrdersDashboard from '../components/orders/OrdersDashboard';
import DeliveriesMap from '../components/deliveries/DeliveriesMap';
import NewOrderModal from '../components/orders/NewOrderModal';
import ImportOrdersModal from '../components/orders/ImportOrdersModal';

const { Title } = Typography;
const { TabPane } = Tabs;

const Orders = () => {
  const [isNewOrderModalVisible, setIsNewOrderModalVisible] = useState(false);
  const [isImportModalVisible, setIsImportModalVisible] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const showNewOrderModal = () => {
    setIsNewOrderModalVisible(true);
  };

  const handleNewOrderModalCancel = () => {
    setIsNewOrderModalVisible(false);
  };

  const handleNewOrderSuccess = () => {
    setIsNewOrderModalVisible(false);
    setRefreshKey(prevKey => prevKey + 1);
  };

  const showImportModal = () => {
    setIsImportModalVisible(true);
  };

  const handleImportModalCancel = () => {
    setIsImportModalVisible(false);
  };

  const handleImportSuccess = () => {
    setIsImportModalVisible(false);
    setRefreshKey(prevKey => prevKey + 1);
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <div>
          <Breadcrumb
            items={[
              {
                href: '/',
                title: <HomeOutlined />,
              },
              {
                title: 'Commandes',
              },
            ]}
            className="mb-2"
          />
          <Title level={2}>Gestion des Commandes</Title>
        </div>
        <Space>
          {/* <Button 
            icon={<ShopOutlined />}
            size="large"
            onClick={showImportModal}
          >
            Importer depuis Shopify
          </Button> */}
          <Button 
            type="primary" 
            icon={<PlusOutlined />} 
            size="large"
            onClick={showNewOrderModal}
          >
            Nouvelle Commande
          </Button>
        </Space>
      </div>

      <Tabs defaultActiveKey="dashboard" size="large">
        <TabPane 
          tab={
            <span>
              <ShoppingOutlined />
              Tableau de bord
            </span>
          } 
          key="dashboard"
        >
          <OrdersDashboard key={`dashboard-${refreshKey}`} />
        </TabPane>
        <TabPane 
          tab={
            <span>
              <ShoppingOutlined />
              Commandes
            </span>
          } 
          key="orders"
        >
          <OrdersList key={`orders-${refreshKey}`} />
        </TabPane>
        {/* <TabPane 
          tab={
            <span>
              <ShoppingOutlined />
              Livraisons
            </span>
          } 
          key="deliveries"
        >
          <DeliveriesMap key={`deliveries-${refreshKey}`} />
        </TabPane> */}
      </Tabs>

      <NewOrderModal 
        visible={isNewOrderModalVisible} 
        onCancel={handleNewOrderModalCancel}
        onSuccess={handleNewOrderSuccess}
      />

      <ImportOrdersModal
        visible={isImportModalVisible}
        onCancel={handleImportModalCancel}
        onSuccess={handleImportSuccess}
      />
    </div>
  );
};

export default Orders; 